import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface CustomContentCollateralEntityParams {
  custom_content_collateral_id: number;
}
export class CustomContentCollateralEntity extends BaseEntityClass {
  custom_content_collateral_id: number;
  constructor(params: CustomContentCollateralEntityParams) {
    super();
    this.type = "custom_content_collateral";
    this.entity_version = 2;
    this.custom_content_collateral_id = params.custom_content_collateral_id;
  }
}
